import React from 'react';

function SemiCurriculum() {
  return (
    <div>
      {/* Hero Section */}
      <div style={{ backgroundColor: "#f8f9fa", padding: "60px 0 50px 0" }}>
        <div className="container">
          <div style={{ maxWidth: "800px" }}>
            <h1 style={{
              fontSize: "clamp(2rem, 4vw, 2.5rem)",
              fontWeight: "700",
              color: "#1a1a2e",
              marginBottom: "16px",
              letterSpacing: "-0.02em"
            }}>
              IRO Semifinal Exam Curriculum Guide
            </h1>
            <p style={{
              fontSize: "1.1rem",
              color: "#555",
              lineHeight: "1.7"
            }}>
              Official curriculum guide to help you prepare for the IRO Semifinal Examination.
            </p>
          </div>
        </div>
      </div>

      <div className="container" style={{ padding: "50px 0 80px 0" }}>
        <div style={{
          background: "#fff",
          borderRadius: "16px",
          overflow: "hidden",
          boxShadow: "0 4px 20px rgba(0, 0, 0, 0.06)",
          border: "1px solid #e8eef3"
        }}>
          {/* Header */}
          <div style={{
            padding: "20px 28px",
            borderBottom: "1px solid #e8eef3",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            flexWrap: "wrap",
            gap: "12px"
          }}>
            <h2 style={{
              fontSize: "1.25rem",
              fontWeight: "600",
              color: "#1a1a2e",
              margin: 0
            }}>
              Curriculum Document
            </h2>
            <a
              href="https://docs.google.com/document/d/1wVRxCWApHyJ3NH1YUa5WV5_dirOwp9Yoi8qdnb-u7Ak/"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: "6px",
                padding: "8px 16px",
                borderRadius: "8px",
                backgroundColor: "#004d99",
                color: "#fff",
                textDecoration: "none",
                fontSize: "0.9rem",
                fontWeight: "500"
              }}
            >
              Open in Google Docs
            </a>
          </div>

          {/* Embedded Document */}
          <iframe
            title="IRO Semifinal Curriculum"
            src="https://docs.google.com/document/d/1wVRxCWApHyJ3NH1YUa5WV5_dirOwp9Yoi8qdnb-u7Ak/preview#view=FitH"
            style={{
              width: "100%",
              height: "800px",
              border: "none"
            }}
            allow="autoplay"
          />
        </div>
      </div>
    </div>
  );
}

export default SemiCurriculum;
